import En from './En';
import Ro from './Ro';

const getCountries = (locale) => {
  // it looks like eval can't evaluate imported variables
  // let lang = eval((locale.charAt(0).toUpperCase() + locale.substring(1).toLowerCase()));
  if (! locale || ! locale.length) {
    return Ro;
  }

  if (locale.toLowerCase() === 'ro') {
    return Ro;
  } else {
    return En;
  }
}

export default getCountries;
